import { createContext } from 'react';

/**
 * FocusableTooltipContext to use by FocusableTooltipWrapper and FocusableTooltipArea components
 */
export const FocusableTooltipContext = createContext(null);
